export default __webpack_public_path__ + "static/media/pullover_start.7ce884ae.svg";